export const CONSENT_STORAGE_KEY = "skandor_consent";
export const CONSENT_OPEN_EVENT = "skandor:open-consent";
export const CONSENT_CHANGE_EVENT = "skandor:consent-change";

export interface ConsentState {
  analytics: boolean;
  marketing: boolean;
  ts: number;
}

type DataLayerRecord = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: DataLayerRecord[];
  }
}

export const getConsent = (): ConsentState | null => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ConsentState>;
    if (typeof parsed.analytics !== "boolean" || typeof parsed.marketing !== "boolean") return null;
    return { analytics: parsed.analytics, marketing: parsed.marketing, ts: parsed.ts ?? Date.now() };
  } catch {
    return null;
  }
};

export const setConsent = (analytics: boolean, marketing: boolean): ConsentState => {
  const state: ConsentState = { analytics, marketing, ts: Date.now() };

  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* storage unavailable — consent still applies for this page view */
  }

  window.gtag?.("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "consent_update", analytics, marketing });
  window.dispatchEvent(new CustomEvent<ConsentState>(CONSENT_CHANGE_EVENT, { detail: state }));

  return state;
};

/** Re-opens the cookie banner (used by the footer "Cookie preferences" link). */
export const openConsentPreferences = (): void => {
  window.dispatchEvent(new Event(CONSENT_OPEN_EVENT));
};
